import { Book, Config, immerable, Summary, SummaryArticle, SummaryPart } from '@topwrite/common';

Book.prototype[immerable] = true;
Summary.prototype[immerable] = true;
SummaryPart.prototype[immerable] = true;
SummaryArticle.prototype[immerable] = true;
Config.prototype[immerable] = true;
